import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Copy, Sparkles, User } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { format } from "date-fns";

interface ChatMessageProps {
  role: "user" | "assistant";
  content: string;
  timestamp: Date;
}

export const ChatMessage = ({ role, content, timestamp }: ChatMessageProps) => {
  const { toast } = useToast();
  const isAssistant = role === "assistant";

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    toast({
      title: "Copied to clipboard",
      duration: 2000,
    });
  };

  return (
    <div className={`flex gap-3 ${isAssistant ? "flex-row" : "flex-row-reverse"}`}>
      <Avatar className="h-8 w-8 flex-shrink-0">
        <AvatarFallback className={isAssistant ? "bg-primary text-primary-foreground" : "bg-secondary"}>
          {isAssistant ? <Sparkles className="h-4 w-4" /> : <User className="h-4 w-4" />}
        </AvatarFallback>
      </Avatar>
      
      <div className={`flex flex-col gap-1 max-w-[80%] ${isAssistant ? "items-start" : "items-end"}`}>
        <Card className={`p-3 ${isAssistant ? "bg-muted" : "bg-primary text-primary-foreground"}`}>
          <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
        </Card>
        
        <div className="flex items-center gap-2 px-1">
          <span className="text-xs text-muted-foreground">
            {format(timestamp, "h:mm a")}
          </span>
          {isAssistant && (
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6"
              onClick={handleCopy}
            >
              <Copy className="h-3 w-3" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
